import styled from 'styled-components';

export const Footer = styled.div`
  background-color: #265689;
  width: 100%;
  height: 100px;
  padding-top: 25px;

  a {
    color: white;
  }

  ol {
    padding: 0;

    li:not(:first-child) {
      padding-left: 20px;
    }
    li {
      display: inline;
    }
  }

  hr {
    background-color: white;
    display: block;
    width: 80%;
    margin: 0 auto 25px;
  }
`;

export const Links = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
